var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Minus"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"DESKTOP","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"1.4.3-Storage-details","transform":"translate(-47.000000, -673.000000)","fill":"#BB4300"},React.createElement("polygon",{"id":"Minus","points":"52.0117647 674.918489 47 674.918489 47 673.081511 52.0117647 673.081511 53.9882353 673.081511 59 673.081511 59 674.918489 53.9882353 674.918489"})))]);
}

Minus.defaultProps = {"width":"12px","height":"2px","viewBox":"0 0 12 2","version":"1.1"};

module.exports = Minus;

Minus.default = Minus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/minus.svg
// module id = 1501
// module chunks = 0